// (function () {
//     'use strict';

//     angular.module("imApp").factory("bankReconciliationAnalysisService", ['$ihttp', function ($ihttp) {
//         let service = {
//             getSetting: function (parms) {
//                 return $ihttp.post({
//                     method: 3376,
//                     parameters: parms || {}
//                 });
//             }
//         };

//         return service;
//     }]);
// })();
